<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12" lg="6" offset-lg="3">
        <a href="#top"></a>
        <section id="Introduction">
          <HeaderComponent class="pt-8" />
        </section>
      </v-col>
    </v-row>
    <v-row class="mt-16">
      <v-col cols="12" sm="12" lg="10" offset-lg="1">
        <!-- <a href="https://andromeda.technology"> -->
        <v-img src="/img/andromeda-technology-overview.png" contain />
        <!-- </a> -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" lg="8" offset-lg="2">
        <IntroComponent class="mt-16 py-16" />
        <InterestsComponent class="my-16 py-16" />
        <LinksComponent class="mb-16 py-16" />
        <section id="Apps">
          <StartupsComponent class="py-16" />
        </section>
        <section id="Essays">
          <EssaysComponent class="py-16" />
        </section>
        <section id="Podcasts">
          <PodcastsComponent class="py-16" />
        </section>
        <section id="Projects">
          <ProjectsComponent class="py-16" />
        </section>
        <CollaborationsComponent v-if="false" class="py-16" />
        <section id="Contact">
          <SkillsComponent class="mt-8" />
          <ContactComponent class="pb-16 mb-16" />
        </section>
        <ScrollToTopComponent class="py-16 my-16" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="ts">
import IntroComponent from './IntroComponent.vue';
import LinksComponent from './LinksComponent.vue';
import EssaysComponent from './EssaysComponent.vue';
import SkillsComponent from './SkillsComponent.vue';
import ContactComponent from './ContactComponent.vue';
import StartupsComponent from './StartupsComponent.vue';
import PodcastsComponent from './PodcastsComponent.vue';
import ProjectsComponent from './ProjectsComponent.vue';
import InterestsComponent from './InterestsComponent.vue';
import ScrollToTopComponent from './ScrollToTopComponent.vue';
import CollaborationsComponent from './CollaborationsComponent.vue';
import { defineComponent } from 'vue';
import HeaderComponent from './HeaderComponent.vue';

export default defineComponent({
  name: 'HelloWorld',
  components: {
    HeaderComponent,
    IntroComponent,
    LinksComponent,
    SkillsComponent,
    EssaysComponent,
    ContactComponent,
    StartupsComponent,
    PodcastsComponent,
    ProjectsComponent,
    InterestsComponent,
    ScrollToTopComponent,
    CollaborationsComponent,
  },
});
</script>
<style lang="scss">
a {
  text-decoration: none !important;
}
</style>
